import { useContext, useEffect, useState } from 'react';
import { UserContext } from 'context/User/UserContext';
import { getTrainingTrack } from '../_api';
import { TrainingTrackDTO } from '../_classes';
import PageWithBreadcrumbs from '../layouts/PageWithBreadcrumbs';
import TrainingTrackForm from './FormView';

/**
 * Epic Training Track Form for creating new or editing existing training tracks
 * @param {any} props properties from router
 * @returns Training Track Editor page view
 */
const EditorView = props => {
	const query = new URLSearchParams(props.location.search);
	const id = query.get('id');
	const isNew = !!!id;
	/**
	 * @type {import('context/User/UserContext').ContextUser}
	 */
	const contextUser = useContext(UserContext);
	const maintenanceUser = contextUser?.userInfo?.impersonationProfile
		? { ...contextUser?.userInfo?.impersonationProfile }
		: { ...contextUser.userInfo.userProfile };

	const [sTrainingTrack, setTrainingTrack] = useState(null);

	useEffect(() => {
		let active = true;

		async function fetchApi() {
			const selectedTrainingTrack = await getTrainingTrack(id);
			setTrainingTrack(selectedTrainingTrack);
		}

		if (active && id) {
			fetchApi();
		}
		if (active && !id) {
			setTrainingTrack(new TrainingTrackDTO());
		}

		return () => {
			active = false;
		};
	}, [id]);

	return (
		<PageWithBreadcrumbs
			currentPageLabel={
				isNew ? 'New Training Track' : 'Training Track Editor'
			}
		>
			{(isNew || sTrainingTrack) && (
				<TrainingTrackForm
					trainingTrack={sTrainingTrack}
					isNew={isNew}
					maintenanceInformation={maintenanceUser}
				/>
			)}
		</PageWithBreadcrumbs>
	);
};

export default EditorView;
